// Updated ProjetsMatchesDashboard with mobile dropdown tabs
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchMatches, fetchMatchesDonneurOrdre, fetchMessages, fetchMessagesDonneurOrdre, selectMatch, selectMatchDonneurOrdre } from "../../redux/actions/matchActions";
import ProjectCard from "../ProjectCard";
import ChatConversation from "../ChatConversation";
import FormModalPropositionCommerciale from "../FormModalPropositionCommerciale";
import useWebSocket from "../../hooks/useWebSocket";
import VisioTab from "../VisioTab";
import { useGlobalCall } from "../../hooks/useGlobalCall";
import ChatConversationDonneurOrdre from "../ChatConversationDonneurOrdre";
import { setActiveTabMatchAppelOffre } from "../../redux/actions/dashboardActions";

const AppelsOffresMatchesDashboard = () => {
    const dispatch = useDispatch();
    const { matchesDonneurOrdre, selectedMatchDonneurOrdre } = useSelector((state) => state.match);
    const { activeTabMatchAppelOffre } = useSelector((state) => state.dashboard);
    const { token, user } = useSelector((state) => state.auth);
    const usersOnline = useSelector((state) => state.online.usersOnline);
    const globalCallRef = useGlobalCall();

    const [activeTab, setActiveTab] = useState("projet");
    const [showPropositionModal, setShowPropositionModal] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const wsRef = useRef(null);
    const { sendTypingStatus, addCallListener } = useWebSocket(wsRef);

    const isMobile = typeof window !== "undefined" && window.innerWidth < 768;

    useEffect(() => {
        if (token) dispatch(fetchMatchesDonneurOrdre(token));
    }, [dispatch, token]);

    const containerStyle = { padding: "20px", display: "flex", flexDirection: "column", gap: "15px" };
    const listCard = { display: "flex", flexDirection: "column", alignItems: "center", padding: "15px", border: "1px solid #ddd", borderRadius: "10px", background: "#fff", cursor: "pointer" };
    const listCardHover = { borderColor: "#007bff", boxShadow: "0 4px 12px rgba(0,0,0,0.12)" };

    const badge = (online) => ({
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        background: online ? "#d4f8d4" : "#f0f0f0",
        color: online ? "#258f25" : "#555",
        border: `1px solid ${online ? "#42c442" : "#aaa"}`,
        padding: "4px 8px",
        borderRadius: "6px",
        fontSize: "13px",
        marginLeft: "10px",
    });

    const tabList = [
        { id: "projet", label: "📁 Projet" },
        { id: "chat", label: "💬 Conversation" },
        { id: "props", label: "🧾 Propositions" },
    ];

    if (!selectedMatchDonneurOrdre) {
        return (
            <div style={containerStyle}>
                <h2 style={{ textAlign: "center" }}>Mes Appels d'offres Matchés</h2>
                {matchesDonneurOrdre.length === 0 && <p>Aucun appel d'offres matché pour le moment.</p>}

                {matchesDonneurOrdre.map((match) => {
                    const isOnline = usersOnline[match.donneurOrdre?.idUser] === true;

                    return (
                        <div
                            key={match.id}
                            style={listCard}
                            onClick={() => dispatch(selectMatchDonneurOrdre(match))}
                            onMouseEnter={(e) => Object.assign(e.currentTarget.style, listCardHover)}
                            onMouseLeave={(e) => Object.assign(e.currentTarget.style, listCard)}
                        >
                            <span style={badge(isOnline)}>{isOnline ? "En ligne" : "Hors ligne"}</span>

                            <h3>{match.projet?.titreProjet}</h3>
                            <p style={{ opacity: 0.7 }}>{match.client?.raisonSocialeClient}</p>
                        </div>
                    );
                })}
            </div>
        );
    }

    const isPrestataire = user.rolesUser[0].roleUser === "prestataire";
    const toUserId = isPrestataire ? selectedMatchDonneurOrdre?.donneurOrdre?.idUser : selectedMatchDonneurOrdre?.prestataire?.idUser;
    const isOnline = usersOnline[toUserId] === true;

    const handleCall = () => {
        window.dispatchEvent(
            new CustomEvent("setCallInfo", {
                detail: { fromUserId: user.idUser, toUserId: toUserId, matchId: selectedMatchDonneurOrdre.id },
            })
        );
        globalCallRef.current?.();
    };

    return (
        <div style={containerStyle}>
            <button
                style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px",
                    background: "#f5f5f5",
                    border: "1px solid #d4d4d4",
                    padding: "10px 16px",
                    borderRadius: "8px",
                    fontSize: "15px",
                    cursor: "pointer",
                    color: "#333",
                }}
                onClick={() => dispatch(selectMatchDonneurOrdre(null))}
            >
                <span style={{ fontSize: "18px" }}>←</span> Retour aux projets
            </button>

            <div style={{ border: "1px solid #ccc", borderRadius: "10px", padding: "25px", background: "#fff" }}>
                <h2>{selectedMatchDonneurOrdre?.projet?.titreProjet}</h2>
                <span style={badge(isOnline)}>{isOnline ? "En ligne" : "Hors ligne"}</span>

                {/* Desktop Tabs */}
                {!isMobile && (
                    <div style={{ display: "flex", gap: "12px", marginTop: "20px", marginBottom: "15px" }}>
                        {tabList.map((tab) => (
                            <button
                                key={tab.id}
                                style={{
                                    padding: "8px 14px",
                                    cursor: "pointer",
                                    borderRadius: "6px",
                                    background: activeTabMatchAppelOffre === tab.id ? "#007bff" : "#f1f1f1",
                                    color: activeTabMatchAppelOffre === tab.id ? "white" : "#333",
                                    border: "none",
                                }}
                                onClick={() => {dispatch(setActiveTabMatchAppelOffre(tab.id));console.log(activeTabMatchAppelOffre)}}
                            >
                            {tab.label} ▾

                            </button>
                        ))}

                        {/* {isOnline && <button onClick={handleCall}>📞 Appel vidéo</button>} */}
                    </div>
                )}

                {/* Mobile Dropdown */}
                {isMobile && (
                    <div style={{ marginTop: "20px", marginBottom: "15px" }}>
                        <button
                            style={{ padding: "10px", borderRadius: "6px", background: "#f1f1f1", width: "100%" }}
                            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                        >
                            {tabList.find((t) => t.id === activeTabMatchAppelOffre)?.label} ▾
                        </button>
                        {mobileMenuOpen && (
                            <div style={{ marginTop: "10px", border: "1px solid #ddd", borderRadius: "6px", background: "#fafafa" }}>
                                {tabList.map((tab) => (
                                    <div
                                        key={tab.id}
                                        style={{ padding: "12px", cursor: "pointer" }}
                                        onClick={() => {
                                            dispatch(setActiveTabMatchAppelOffre(tab.id));
                                            console.log(activeTab);
                                            setMobileMenuOpen(false);
                                        }}
                                    >
                                        {tab.label}
                                    </div>
                                ))}

                                {/* {isOnline && (
                                    <div style={{ padding: "12px", cursor: "pointer" }} onClick={handleCall}>
                                        📞 Appel vidéo
                                    </div>
                                )} */}
                            </div>
                        )}
                    </div>
                )}

                {activeTabMatchAppelOffre === "projet" && (
                    <ProjectCard
                        project={selectedMatchDonneurOrdre.projet}
                        idUserClient={selectedMatchDonneurOrdre.donneurOrdre.idUser}
                        onLike={null}
                        onPass={null}
                        isReceivedLike={false}
                        isAlreadyMatched={true}
                    />
                )}

                {activeTabMatchAppelOffre === "chat" && (
                    <ChatConversationDonneurOrdre toUserId={toUserId} onMessageSent={() => dispatch(fetchMessagesDonneurOrdre(token, selectedMatchDonneurOrdre.id))} />
                )}

                {activeTabMatchAppelOffre === "props" && (
                    <>
                        <h3>Vos Propositions Commerciales</h3>
                        <button onClick={() => setShowPropositionModal(true)} style={{ marginTop: "12px" }}>
                            ➕ Faire une nouvelle proposition
                        </button>
                        {showPropositionModal && (
                            <FormModalPropositionCommerciale
                                idProjet={selectedMatchDonneurOrdre.projet.idProjet}
                                onClose={() => setShowPropositionModal(false)}
                                token={token}
                            />
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default AppelsOffresMatchesDashboard;
